/**
 * Check if a fellow is inactive
 * @param {number|string} fellowId - The fellow's ID
 * @param {Array} fellowsArray - Array of all fellows
 * @returns {boolean} - True if fellow is inactive
 */
export const isFellowInactive = (fellowId, fellowsArray) => {
  const fellow = fellowsArray.find((f) => f.id === parseInt(fellowId));
  return fellow?.attributes?.active === false;
};

/**
 * Check if a non-AAS referee is inactive
 * @param {number|string} refereeId - The referee's ID
 * @param {Array} nonAasRefereesArray - Array of all non-AAS referees
 * @returns {boolean} - True if referee is inactive
 */
export const isNonAasRefereeInactive = (refereeId, nonAasRefereesArray) => {
  const referee = nonAasRefereesArray.find((r) => r.id === parseInt(refereeId));
  return referee?.attributes?.isActive === false;
};

/**
 * Get the full name of a fellow
 * @param {number|string} fellowId - The fellow's ID
 * @param {Array} fellowsArray - Array of all fellows
 * @returns {string} - The fellow's full name
 */
export const getFellowName = (fellowId, fellowsArray) => {
  const fellow = fellowsArray.find((f) => f.id === parseInt(fellowId));
  if (fellow?.attributes) {
    return `${fellow.attributes.name} ${fellow.attributes.lastName}`;
  }
  return '';
};

/**
 * Get the full name of a non-AAS referee
 * @param {number|string} refereeId - The referee's ID
 * @param {Array} nonAasRefereesArray - Array of all non-AAS referees
 * @returns {string} - The referee's full name
 */
export const getNonAasRefereeName = (refereeId, nonAasRefereesArray) => {
  const referee = nonAasRefereesArray.find((r) => r.id === parseInt(refereeId));
  if (referee?.attributes) {
    return `${referee.attributes.name} ${referee.attributes.lastName}`;
  }
  return '';
};

/**
 * Get the inactive status string for a referee
 * @param {Object} referee - The referee object with refereeFellowId or nonAasRefereeId
 * @param {Array} fellowsArray - Array of all fellows
 * @param {Array} nonAasRefereesArray - Array of all non-AAS referees
 * @returns {string} - Returns (Deceased) or (Inactive) if inactive, empty string otherwise
 */
export const getRefereeInactiveStatus = (
  referee,
  fellowsArray,
  nonAasRefereesArray,
) => {
  if (referee.refereeFellowId) {
    return isFellowInactive(referee.refereeFellowId, fellowsArray)
      ? ' (Deceased)'
      : '';
  }
  if (referee.nonAasRefereeId) {
    return isNonAasRefereeInactive(referee.nonAasRefereeId, nonAasRefereesArray)
      ? ' (Inactive)'
      : '';
  }
  return '';
};
